import axios from 'axios'//没有用到,删除也可以

//excel下载
export function downloadFile(blob, fileName) {
	//ie
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		window.navigator.msSaveOrOpenBlob(blob, fileName + ".xls");
	} else {//其他
		const download = document.createElement('a')
		download.style.display = 'none'
		download.href = URL.createObjectURL(blob)
		download.download = fileName + ".xls"
		document.body.appendChild(download)
		download.click()
		URL.revokeObjectURL(blob)
		document.body.removeChild(download)
	}
};

/**
   *获取当前时间
   *format=1精确到天
   *format=2精确到分
  */
export function getCurrentDate(format) {
	var now = new Date();
	var year = now.getFullYear(); //得到年份
	var month = now.getMonth();//得到月份
	var date = now.getDate();//得到日期
	var day = now.getDay();//得到周几
	var hour = now.getHours();//得到小时
	var minu = now.getMinutes();//得到分钟
	var sec = now.getSeconds();//得到秒
	month = month + 1;
	if (month < 10) month = "0" + month;
	if (date < 10) date = "0" + date;
	if (hour < 10) hour = "0" + hour;
	if (minu < 10) minu = "0" + minu;
	if (sec < 10) sec = "0" + sec;
	var time = "";
	//精确到天
	if (format == 1) {
		time = year + "-" + month + "-" + date;
	}
	//精确到分
	else if (format == 2) {
		time = year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
	}
	return time;
};

//导出
export function exportExecl(url, tit, schoolCode, current, size, searchYear, searchTerm, searchKey, checkStatus, startDate, endDate, resType1, grade, disciplineCode, startDate1, startDate2, endDate1, endDate2, trainingType1) {
	const exportData = {
		schoolCode: schoolCode,
		pageNum: current || "",
		pageSize: size || "",
		schoolTerm: searchTerm || "",
		schoolYear: searchYear || "",
		keyword: searchKey || "",
		checkStatus: checkStatus || "",
		startDate: startDate || '',
		endDate: endDate || '',
		resType1: resType1 || '',
		grade: grade || '',
		disciplineCode: disciplineCode || '',
		startDate1: startDate1 || '',
		startDate2: startDate2 || '',
		endDate1: endDate1 || '',
		endDate2: endDate2 || '',
		trainingType1: trainingType1 || '',
	};
	if (tit.indexOf("教师档案") != -1) {
		exportData.userName = searchKey || ""
	}
	axios.post(url, exportData, {
		responseType: "blob",
	})
		.then((res) => {
			const blob = new Blob([res], {
				type: "application/vnd.ms-excel;charset=GBK",
			});
			downloadFile(blob, tit);
		});
};

//模板下载
export function downloadExecl(url, tit, params = {}) {
	axios.get(url, { params: params, responseType: "blob" })
		.then((res) => {
			const blob = new Blob([res], {
				type: "application/vnd.ms-excel;charset=GBK",
			});
			downloadFile(blob, tit);
		});
};

//判断只能输入一位小数（负数）
export function clearNoNum(num) {
	let t = num.charAt(0);
	//先把非数字的都替换掉，除了数字和.
	num = num.replace(/[^\d.]/g, "");
	//必须保证第一个为数字而不是.
	num = num.replace(/^\./g, "");
	//保证只有出现一个.而没有多个.
	num = num.replace(/\.{2,}/g, ".");
	//保证.只出现一次，而不能出现两次以上
	num = num.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
	// 只能输入一个小数
	num = num.replace(/^(-)*(\d+)\.(\d).*$/, "$1$2.$3");
	// 如果没有小数点，首位不能为类似于 01、02的金额
	if (num.indexOf(".") < 0 && num !== "") {
		num = parseFloat(num);
	}
	//如果第一位是负号，则允许添加   如果不允许添加负号 可以把这块注释掉
	if (t == '-') {
		num = '-' + num;
	}
	return num;
}